<template >
  <base-dialog-form ref="gestVoucherDialog" :title="$t('edit_voucher')" :text="voucherCode" color="secondary"
    icon="mdi-ticket-percent">
    <template v-slot:actions>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn @click="saveVoucher" color="success">{{ $t("save") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <form>
      <v-row>
        <v-col md="2" cols="6">
          <my-datepicker v-model="dateInz" :label="$t('date_inz')" required="true" />
        </v-col>
        <v-col md="2" cols="6">
          <my-datepicker v-model="dateEnd" :label="$t('date_end')" required="true" />
        </v-col>
        <v-col md="2" cols="5">
          <v-select :items="listType" v-model="type" :label="$t('type')" />
        </v-col>
        <v-col md="1" cols="5">
          <v-text-field type="number" v-model="qta" v-if="type == '*POINT'" :label="$t('quantity')" :rules="required"
            hide-details="auto"></v-text-field>
        </v-col>

        <v-col md="1" cols="2">
          <v-text-field v-if="type == '*POINT'" type="number" v-model="punti" :label="$t('point')" :rules="required"
            hide-details="auto"></v-text-field>
        </v-col>
        <v-col md="2" cols="6">
          <v-radio-group row v-model="attivo">
            <v-radio :label="$t('active_m_s')" value="1"></v-radio>
            <v-radio :label="$t('disabled_m_s')" value="0"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col md="2" cols="6">
          <v-switch v-model="ifGeo" :label="$t('geo_voucher')"></v-switch>
        </v-col>

        <v-col cols="12">
          <v-text-field v-model="name" :label="$t('title')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field v-model="success" :label="$t('redeem_message')" :rules="required"
            hide-details="auto"></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="type == '*URL'">
        <v-col cols="12">
          <v-text-field v-model="url" :label="$t('link')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="type == '*TEXT'">
        <v-col cols="12">
          <v-text-field v-model="text" :label="$t('text')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="ifGeo">
        <v-col md="4" cols="6">
          <v-text-field v-model="coordX" :label="$t('latitude')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field v-model="coordY" :label="$t('longitude')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>
        <v-col md="2" cols="6">
          <v-text-field v-model="range" :label="$t('distance')" :rules="required" hide-details="auto"></v-text-field>
        </v-col>
        <v-col md="2" cols="6">
          <v-switch v-model="searchGeo" :label="$t('search_coordinates')"></v-switch>
        </v-col>
        <v-col v-if="searchGeo" cols="12">
          <select-on-map @coordinates="updateCoordinates" :coordX="coordX" :coordY="coordY" style="height: 800px"
            showCoordinates="false" />
        </v-col>
      </v-row>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import selectOnMap from "@/widget/selectOnMap.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";

export default {
  name: "edit-voucher",
  components: { MyDatepicker, selectOnMap },
  data() {
    return {
      voucherCode: null,
      listType: [
        { value: "*POINT", text: this.$t("point") },
        { value: "*TEXT", text: this.$t("text") },
        { value: "*URL", text: this.$t("link") },
      ],
      ifGeo: false,
      searchGeo: false,
      name: null,
      text: null,
      type: null,
      url: null,
      punti: null,
      qta: null,
      dateInz: null,
      dateEnd: null,
      attivo: null,
      success: null,
      coordX: null,
      coordY: null,
      coordinates: null,
      range: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(voucherCode) {
      this.voucherCode = voucherCode;
      this.loadData();
      this.$refs.gestVoucherDialog.open();
    },
    loadData() {
      let _ = this;
      let url = "/auth/voucher/getVoucher/" + _.voucherCode;
      if (_.voucherCode) {
        // Eventi aperti
        _.chiamataAxios("GET", url).then((response) => {
          _.name = response.data.name;
          _.text = response.data.text;
          _.type = response.data.type;
          _.url = response.data.url;
          _.punti = response.data.punti;
          _.qta = response.data.qta;
          _.dateInz = response.data.dateInz;
          _.dateEnd = response.data.dateEnd;
          _.attivo = response.data.attivo === 1 ? "1" : "0";
          _.success = response.data.success;
          _.coordX = response.data.coordX;
          _.coordY = response.data.coordY;
          _.range = response.data.range;
          if (
            response.data.coordX > 0 ||
            response.data.coordY > 0 ||
            response.data.range > 0
          )
            _.ifGeo = true;
          else _.ifGeo = false;
        });
      } else {
        _.name = "";
        _.text = "";
        _.type = "*POINT";
        _.url = "";
        _.punti = 0;
        _.qta = 1;
        _.dateInz = new Date();
        _.dateEnd = new Date();
        _.attivo = "1";
        _.success = "";
        _.coordX = null;
        _.coordY = null;
        _.range = null;
      }
    },
    saveVoucher: function () {
      let _ = this;
      let url = "/auth/voucher/createVoucher";
      let method = "PUT";
      if (_.voucherCode) {
        url = "/auth/voucher/saveVoucher/" + _.voucherCode;
        method = "POST";
      }
      _.chiamataAxios(method, url, {
        dialogLoader: true,
        body: {
          name: _.name,
          text: _.text,
          type: _.type,
          url: _.url,
          punti: _.punti,
          qta: _.qta,
          dateInz: _.dateInz,
          dateEnd: _.dateEnd,
          attivo: _.attivo === "1" ? 1 : 0,
          success: _.success,
          coordX: _.ifGeo ? _.coordX : null,
          coordY: _.ifGeo ? _.coordY : null,
          range: _.ifGeo ? _.range : null,
        },
      }).then((response) => {
        if (response.msg.esito) {
          Swal.fire({
            type: "success",
            html:
              "<strong>" + response.msg.msgTxt + "</strong>",
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestVoucherDialog.close();
        }
      });
    },
    updateCoordinates(coord) {
      this.coordX = coord.coordX;
      this.coordY = coord.coordY;
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    coordinates: function (newVal, oldVal) {
      // watch it
      _.coordX = newVal.coordX;
      _.coordY = newVal.coordY;
    },
  },
};
</script>
